import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "@/pages/Home";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import NotFound from "@/pages/NotFound";

/**
 * Sektions-Aliase: Sichtbar in der sitemap.xml (z. B. /leistungen)
 * und leiten intern per Hash auf die entsprechende Sektion der Startseite.
 */
const SECTION_ROUTES = [
  { path: "/leistungen", to: "/#leistungen" },
  { path: "/referenzen", to: "/#referenzen" },
  { path: "/ueber", to: "/#ueber" },
  { path: "/über", to: "/#ueber" }, // Umlaut-Variante
  { path: "/kontakt", to: "/#kontakt" },
];

function App() {
  return (
    <div className="App min-h-screen bg-white text-brand-primary">
      <a href="#hauptinhalt" className="skip-link" data-testid="skip-link">
        Zum Hauptinhalt springen
      </a>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          {SECTION_ROUTES.map((r) => (
            <Route
              key={r.path}
              path={r.path}
              element={<Navigate to={r.to} replace />}
            />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
